import { Loader2 } from "lucide-react";

import { SettingsNav } from "@/components/layout/settings-nav";
import { Card, CardContent } from "@/components/ui/card";
import { AccountLogoCard } from "@/features/rdo/components/account-logo-card";
import { useMe } from "@/hooks/use-me.ts";

export function ContaPage() {
	const me = useMe();
	const account = me.data?.account ?? null;

	function body() {
		if (me.isPending) {
			return (
				<div className="page-loading">
					<Loader2 />
				</div>
			);
		}
		if (!account?.admin) {
			return (
				<Card>
					<CardContent className="card-state">
						<p>Só administradores da conta podem alterar estes ajustes.</p>
					</CardContent>
				</Card>
			);
		}
		return <AccountLogoCard account={account} />;
	}

	return (
		<div className="account-settings-page">
			<SettingsNav />

			<div className="page-header">
				<div>
					<h1 className="page-title">Conta</h1>
					<p className="page-subtitle">
						{account ? account.name : "Identidade da conta nos documentos."}
					</p>
				</div>
			</div>

			{body()}
		</div>
	);
}
